import { GameSortOptionsEnum } from "../../types";
import {
  AlphaIcon,
  CommunityScoreIcon,
  DateIcon,
  MyRatingIcon,
  UserRatingIcon,
} from "./icons";

export type SortOptionsType = Record<
  string,
  {
    icon: React.ReactNode;
    name: string;
  }
>;

export const DEFAULT_SORT_OPTION = GameSortOptionsEnum.COMMUNITY_SCORE;

export const SORT_OPTIONS_CONFIG = {
  [GameSortOptionsEnum.COMMUNITY_SCORE]: {
    icon: <CommunityScoreIcon />,
    name: "Community score",
  },
  [GameSortOptionsEnum.MY_RATING]: {
    icon: <MyRatingIcon />,
    name: "My rating",
  },
  [GameSortOptionsEnum.USER_RATING]: {
    icon: <UserRatingIcon />,
    name: "User’s rating",
  },
  [GameSortOptionsEnum.DATE_PLAYED]: {
    icon: <DateIcon />,
    name: "Date experienced",
  },
  [GameSortOptionsEnum.ALPHABETICAL]: {
    icon: <AlphaIcon />,
    name: "Alphabetically",
  },
};

export const WISHLIST_SORT_OPTIONS_CONFIG = {
  [GameSortOptionsEnum.COMMUNITY_SCORE]: {
    icon: <CommunityScoreIcon />,
    name: "Community score",
  },
  [GameSortOptionsEnum.ALPHABETICAL]: {
    icon: <AlphaIcon />,
    name: "Alphabetically",
  },
};
